import { useQuery } from "@tanstack/react-query";
import { useServices } from "index";
import { sortByString } from "utilities/dataSorters";

export const useGetOrganizations = (callback: (selectedOrganizationId: string, selectedOrganizationName: string) => void) => {
  const organizationsService = useServices().organizationsService;
  return useQuery({
    queryKey: ['organizationsList'],
    queryFn: async () => {
      const data = await organizationsService.getOrganizations();
      const sortedData = sortByString(data, 'name', 'ASCENDING');
      if (sortedData && sortedData.length > 0) {
        callback(sortedData[0].id, sortedData[0].name);
      }
      return sortedData;
    },
    refetchOnWindowFocus: false,
  });
}